<div class="w-full">
    <div class="bg-card shadow rounded-2xl p-5 m-4">
        <div class="mb-2">
            <div class="text-2xl font-medium tracking-tight leading-6 truncate">
                Option Type Details
            </div>

            <div class="text-sm breadcrumbs text-center">
                <ul>
                    <li><a [routerLink]="'/configurations/option-type'">{{ (optionDetails$ | async)?.data.name }}</a></li>
                    <li>
                        <div class="text-primary">
                            <b>Option Type Details</b>
                        </div>
                    </li>
                </ul>
            </div>
        </div>

        <div class="flex justify-end">

            <button class="btn btn-outline" (click)="addOptionTypeDetails()">Add New</button>

            <div class="w-18 mx-4">
                <mat-form-field class="w-full">
                    <mat-select [(ngModel)]="filterData.pageSize">
                        <mat-option [value]="10"> 10 </mat-option>
                        <mat-option [value]="20"> 20 </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <mat-form-field class="w-48">
                <input matInput placeholder="Search Item">
                <mat-icon [svgIcon]="'heroicons_solid:magnifying-glass'"></mat-icon>
            </mat-form-field>
        </div>

        <div class="overflow-x-auto">
            <table class="table table-zebra text-center">
                <thead class="header">
                    <tr class="tableHeader-bg-color">
                        <td class="text-center w-8"> No </td>
                        <td class="text-center "> Item Name </td>
                        <td class="text-center "> ID </td>
                        <td class="text-center "> Alternate </td>
                        <td class="text-center w-20"> </td>
                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngIf="(optionDetails$ | async) as optionDetails; else noData">
                        <ng-container *ngIf="optionDetails.data.optionItem.length > 0 ; else noData">
                            <ng-container *ngFor="let data of optionDetails.data.optionItem, let i = index">
                                <tr>
                                    <td>{{ i + 1}} </td>
                                    <td>{{ data.name}} </td>
                                    <td>{{ data.id }}</td>
                                    <td>{{ data.alternate}} </td>
                                    <td class="flex">
                                        <button class="btn btn-remove-bg mx-5" (click)="updateDetailsModal(data)">
                                            <mat-icon style="color:#FFC300"
                                                [svgIcon]="'heroicons_solid:pencil-square'"></mat-icon>
                                        </button>
                                        <button class="btn btn-remove-bg mx-5" (click)="deleteOptionItem(data.id)">
                                            <mat-icon style="color:rgb(232, 88, 88)"
                                                [svgIcon]="'heroicons_solid:trash'"></mat-icon>
                                        </button>
                                    </td>
                                </tr>
                            </ng-container>
                        </ng-container>
                    </ng-container>
                </tbody>

                <ng-template #noData>
                    <tr>
                        <td style="background-color: #f5f5f5;" colspan="10">No data available</td>
                    </tr>
                </ng-template>
            </table>
        </div>

        <!-- pagination -->
        <div class="divider mt-2"></div>
        <div class="join flex justify-between w-full">
            <button class="join-item btn btn-remove-bg" (click)="previousPage()">
                <mat-icon [svgIcon]="'heroicons_outline:arrow-long-left'"></mat-icon>
                Previous</button>
            <button class="join-item">Page 1</button>
            <button class="join-item btn btn-remove-bg" (click)="nextPage()">
                Next
                <mat-icon [svgIcon]="'heroicons_outline:arrow-long-right'"></mat-icon>
            </button>
        </div>
    </div>
</div>